/**
 *
 * MixpanelTracking
 *
 */

import React from 'react';
import qs from 'qs';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Mixpanel from 'utils/mixpanelService';
import TopicsInteraction from 'utils/topicsInteractionService';

const withMixpanelTracking = (eventTitle, object) => WrappedComponent =>
  class extends React.Component {
    UNSAFE_componentWillReceiveProps(nextProps) {
      /* eslint-disable */
      if (
        (
          this.props[object] !== nextProps[object] &&
          !_isEmpty(nextProps[object]) &&
          !_isEmpty(_get(nextProps[object], 'items')) &&
          nextProps.auth.isLoaded
        ) || (
          !this.props.auth.isLoaded &&
          nextProps.auth.isLoaded &&
          !_isEmpty(nextProps[object]) &&
          !_isEmpty(_get(nextProps[object], 'items'))
        )
      ) {
        const {
          fields: { name, title, article, type: resourceSubtype, blog: isBlog, topics = [], client },
          sys: { id },
        } = nextProps[object].items[0];
        const params = qs.parse(location.search.slice(1));
        const searchTerm = params['search-term'];
        let subtype;
        let blog;
        const clientExclusive = !_isEmpty(client);
        if (object === 'app') {
          if (resourceSubtype === 'Online Therapy')
            subtype = resourceSubtype;
          else
            subtype = 'Apps';
        }
        if (object === 'organization') {
          subtype = resourceSubtype;
        }
        if (object === 'read') {
          subtype = resourceSubtype;
          blog = isBlog || false;
        }
        let topicsList;
        if (object === 'topic') {
          topicsList = `[${title}]`;
        } else {
          topicsList = topics
            .map(topic => _get(topic, 'fields.title', null))
            .filter(topic => topic !== null)
            .sort()
            .map(topicName => `[${topicName}]`)
            .join();
        }

        const trackProperties = {
          name: name || title || article,
          id,
          type: object === 'read' ? 'article' : object,
          subtype,
          blog,
          searchTerm,
          topic_name: topicsList,
          clientExclusive,
        };
        Mixpanel.track(eventTitle, trackProperties);

        delete params['search-term'];
        nextProps.history.replace(`${location.pathname}?${qs.stringify(params)}`);

        if (!_isEmpty(topics)) {
          TopicsInteraction.batchRegisterInteraction({
            topics,
          });
        }
      } else if (
        object === 'resources' &&
        !this.props.auth.isLoaded &&
        nextProps.auth.isLoaded
      ) {
        const params = qs.parse(location.search.slice(1));
        const searchTerm = params['search-term'];

        const trackProperties = {
          searchTerm,
        };
        Mixpanel.track(eventTitle, trackProperties);

        delete params['search-term'];
        nextProps.history.replace(`${location.pathname}?${qs.stringify(params)}`);
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

export default withMixpanelTracking;
